/**
 * Decodes `window.sessionConfig` injected into the HTML by web-frontend-server.
 *
 * Server versions <= v1.0.7 inject a base64-encoded JSON *string*; v1.0.8+
 * injects a raw JSON *object* (a documented breaking change in the server's
 * README). Accept both shapes so tracker/logger initialization — and with it
 * every analytics event (PPWS included) and every remote log line — survives a
 * server image upgrade.
 */

interface RawDashcamMode {
  enabled?: boolean;
  buffer_max_size?: number;
  buffer_max_duration?: number;
  bufferMaxSize?: number;
  bufferMaxDuration?: number;
}

export interface DecodedSessionConfig {
  token?: string;
  session_id?: string;
  logging?: {
    enabled?: boolean;
    matchers?: Array<{
      level?: string;
      package?: string;
      context?: Record<string, string> | null;
    }>;
    dashcam_mode?: RawDashcamMode;
    dashcamMode?: RawDashcamMode;
  };
  [key: string]: unknown;
}

export function decodeSessionConfig(): DecodedSessionConfig | undefined {
  const raw = (window as unknown as { sessionConfig?: unknown }).sessionConfig;
  if (!raw) return undefined;

  if (typeof raw === "object") {
    return raw as DecodedSessionConfig;
  }

  if (typeof raw !== "string") return undefined;

  try {
    const parsed: unknown = JSON.parse(atob(raw));
    return typeof parsed === "object" && parsed !== null
      ? (parsed as DecodedSessionConfig)
      : undefined;
  } catch {
    return undefined;
  }
}
